import React from "react";

import { SelectTags } from "src/app/components/SelectTags/SelectTags";
import getLabels from "./utils/getLabels";
import METHODS from "../../../../helpers/methods";

export default function InfluencerCountriesTags({
  influencerCountriesByProvider,
  influencerSocialProvider,
  influencerCountriesForSelectedProviders,
  isDisabled,
  countryInputValue,
  selectedInfluencerCountries,
  setInfluencerCountry,
  unsetInfluencerCountry,
  clearInfluencerCountries,
  isExpandable,
}) {
  const availableCountries =
    influencerCountriesForSelectedProviders ??
    influencerCountriesByProvider[influencerSocialProvider?.value] ??
    [];

  const feed = availableCountries
    .filter((country) =>
      METHODS.doesTextIncludeSearchTerm(country.label, countryInputValue),
    )
    .map((country) => country.label);

  const values = selectedInfluencerCountries
    ? getLabels(selectedInfluencerCountries)
    : [];

  return (
    <div className="audience-search__input">
      <SelectTags
        feed={feed}
        values={values}
        setValue={setInfluencerCountry}
        unsetValue={unsetInfluencerCountry}
        clearValues={clearInfluencerCountries}
        disabled={isDisabled}
        isExpandable={isExpandable}
      />
    </div>
  );
}
